// import React from "react";
// import { Link } from "react-router-dom";
// import { Col, Row } from "reactstrap";

// const BreadCrumb = ({ title, pageTitle }) => {
//   return (
//     <React.Fragment>
//       <Row>
//         <Col xs={12}>
//           <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//             <h4 className="mb-sm-0">{title}</h4>

//             <div className="page-title-right">
//               <ol className="breadcrumb m-0">
//                 <li className="breadcrumb-item">
//                   <Link to="#">{pageTitle}</Link>
//                 </li>
//                 <li className="breadcrumb-item active">{title}</li>
//               </ol>
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </React.Fragment>
//   );
// };

// export default BreadCrumb;

import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

const BreadCrumb = ({ breadcrumbs }) => {
  return (
    <React.Fragment>
      <Row className="mb-0 mt-0" style={{ padding: "0px 0px 0px 0px" }}>
        <Col xs={12}>
          <div className="page-title-box mb-2">
            <ol className="breadcrumb mt-0 mb-0">
              {breadcrumbs.map((breadcrumb, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item${
                    index === breadcrumbs.length - 1 ? " active" : ""
                  }`}
                >
                  {breadcrumb.url ? (
                    breadcrumb.url === "/security" ? (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => window.history.back()}
                      >
                        {breadcrumb.label}
                      </span>
                    ) : (
                      <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                    )
                  ) : (
                    breadcrumb.label
                  )}
                </li>
              ))}
            </ol>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
